import {
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { FC, useEffect, useState } from "react";
import { io } from "socket.io-client";
import useScreenSize from "../../../utils/use-screen";
import { Link } from "react-router-dom";

interface UserList {
  accountId: string;
  width: string;
  height: string;
}

const CELLS = ["number", "AId", "width", "height"];

export const Online: FC = () => {
  const { isDesktop } = useScreenSize();
  const [list, setList] = useState<Record<string, UserList>>();

  useEffect(() => {
    // Initialize socket connection
    const socket = io(process.env.REACT_APP_ONLINE_GATEWAY, {
      reconnection: true,
      withCredentials: true,
      reconnectionDelay: 2000,
      reconnectionAttempts: 5,
      transports: ["websocket"],
      query: {
        xAdmin: localStorage.getItem("xToken") || "",
        screenwidth: `${window.screen.width}`,
        screenheight: `${window.screen.height}`,
      },
    });

    // Handle connection
    const handleConnect = () => {
      console.log("connected");

      // Emit event to get user list
      socket.emit("userList", {}, (data: Record<string, UserList>) => {
        console.log("Data received:", data);
        setList(data); // Update state with received data
      });
    };

    // Handle disconnection
    const handleDisconnect = () => {
      console.log("disconnected");
    };

    // Set up event listeners
    socket.on("connect", handleConnect);
    socket.on("disconnect", handleDisconnect);
    socket.on("new-list", (data) => {
      setList(data);
    });

    // Cleanup on unmount
    return () => {
      socket.off("connect", handleConnect);
      socket.off("disconnect", handleDisconnect);
      socket.disconnect();
    };
  }, []); // Empty dependency array ensures setup only runs once

  return (
    <Paper
      component={Grid}
      width={isDesktop ? "80vw" : "100vw"}
      overflow={"scroll"}
    >
      <TableContainer>
        <Table aria-labelledby="tableTitle" size={"small"}>
          <TableHead>
            <TableRow>
              {CELLS.map((item) => (
                <TableCell key={item}>{item}</TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {list &&
              Object.keys(list).map((id, key) => (
                <TableRow key={id}>
                  <TableCell>{key + 1}</TableCell>
                  <TableCell>
                    <Link to={"/app/users/?accountId=" + id}>{id}</Link>
                  </TableCell>
                  <TableCell>{list[id].width}</TableCell>
                  <TableCell>{list[id].height}</TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
};
